import React, { Component } from 'react';
import logo from '../../assets/SCCC_LOGO_SMALL.png';
import TextField from '../../materialUi/textField';
import Btn from '../../materialUi/btn';
import Alert from '../../materialUi/Alerts';
import { ResetPassword } from '../../API/API-resetPassword';

class memberForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      emailMessage: '',
      id: '',
      idMessage: '',
      openAlert: false,
      alertBody: '',
      alertLocation: '',
      alertTitle: '',
      alertStay: '',
      alertClose: '',
      disableBtn: false,
    };
  }

  handleID = (value) => {
    let message = '';
    if (value.target.value.length > 0) {
      if (!/^[a-zA-Z0-9@._%+-]+$/i.test(value.target.value)) {
        message = 'Can only contain letters, numbers, or a valid email address';
      } else {
        message = null;
      }
    } else {
      message = 'Membership ID cannot be empty';
    }
    this.setState({ id: value.target.value.toLowerCase(), idMessage: message });
  };

  handleEmail = (value) => {
    let message = '';
    if (value.target.value.length > 0) {
      if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value.target.value)) {
        message = 'Invalid Email';
      } else {
        message = null;
      }
    } else {
      message = 'Email cannot be empty';
    }
    this.setState({ email: value.target.value, emailMessage: message });
  };

  handleResetLink = () => {
    const { id, email, idMessage, emailMessage } = this.state;
    if (idMessage === null || emailMessage === null) {
      this.setState({ disableBtn: true });
      ResetPassword.sendResetMemberLink(id)
        .then((success) => {
          console.log(success);
          this.setState({
            openAlert: true,
            alertLocation: '/memberLogin',
            alertTitle: 'Email Sent',
            alertBody: 'A Reset Link was sent to your email. Follow the Instructions and login again! ',
            alertClose: 'LOGIN',
            alertStay: 'CLOSE',
            disableBtn: false,
          });
        })
        .catch((error) => {
          if (error.response.status === 500 || error.response.status === 404) return this.setState({
            openAlert: true,
            alertLocation: '/adminForgotPassword',
            alertTitle: 'SERVER ERROR!',
            alertBody: 'There is an error in the server. Please try again later!',
            alertClose: 'hidden',
            alertStay: 'CLOSE',
            disableBtn: false,
          });
          if (error.response.status === 401) return this.setState({
              openAlert: true,
              alertLocation: '/adminForgotPassword',
              alertTitle: 'User not found!',
              alertBody: 'The User was not found! Please check the data entered.',
              alertClose: 'hidden',
              alertStay: 'CLOSE',
              disableBtn: false,
            });
          if (error.response.status === 402) return this.setState({
              openAlert: true,
              alertLocation: '/adminForgotPassword',
              alertTitle: 'There is no email linked to this membership',
              alertBody: `Please contact Scadding Court
              Community Centre to update your email address, and help you reset your password. Contact information: (416)-392-0335`,
              alertClose: 'hidden',
              alertStay: 'CLOSE',
              disableBtn: false,
            });
          
        });
    } else {
      this.setState({
        idMessage: idMessage === '' ? 'Required field!' : idMessage,
        emailMessage: emailMessage === '' ? 'Required field!' : emailMessage,
      });
    }
  };

  render() {
    const { openAlert, alertLocation, alertTitle, alertBody, alertClose, alertStay, email, emailMessage, disableBtn, id, idMessage } = this.state;
    return (
      <div className="container text-center">
        <div className="row  header text-center pt-4">
          <div className="col-12 text-left">
            <div className="-Back-to-Member-lis" onClick={() => this.props.history.push('/memberLogin')} onKeyPress={() => this.props.history.push('/memberLogin')} role="button" tabIndex={0}>
              &lt; Back to login
            </div>
          </div>
          <div className="col-12 text-center mt-5">
            <img src={logo} alt="Logo" />
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center flex-wrap">
          <div className="shadow-sm login-box ">
            <div className="row">
              <div className="col-12">
                <h1 className="Admin-Login ">Forgot Password</h1>
              </div>
              <div className="col-12">
                <h2 className="Enter-your-email-add">Please enter your <b>email address, membership ID or membership card number</b> and we will send you a link to reset your password.</h2>
              </div>
              <div className="col-12">
                {/* <TextField
                  label="Enter your email, Membership ID or Membership Card"
                  id="Email"
                  value={email}
                  handleChanges={(value) => this.handleEmail(value)}
                  helperText={emailMessage}
                  error={emailMessage !== '' && emailMessage !== null}
                  readOnly={false}
                />
                <div>
                  Or
                </div> */}
                <TextField
                  label="Email, Membership ID or Membership Card"
                  id="Membership ID/ Membership Card"
                  value={id}
                  handleChanges={(value) => this.handleID(value)}
                  helperText={idMessage}
                  error={idMessage !== '' && idMessage !== null}
                  readOnly={false}
                />
              </div>
              <div className="col-12 mt-5 text-center">
                <Btn
                  label="Send Reset Link"
                  disable={disableBtn}
                  onClick={this.handleResetLink}
                  bgColor="#e76f50"
                  color="white"
                  bgColorHover="#ff8c68"
                  colorHover="white"
                  height={42}
                  width={window.innerWidth < 600 ? 295 : 395}
                />
              </div>
            </div>
            <Alert open={openAlert} close={() => this.setState({ openAlert: false })} location={alertLocation} title={alertTitle} body={alertBody} stay={alertStay} leave={alertClose} />
          </div>
        </div>
      </div>
    );
  }
}

export default memberForgotPassword;
